<template>
  <div id="topic-mapping-detail">
    <h1 class="page-header">
      Maping Detail
    </h1>
    <button class="btn btn-inverse m-r-10 m-b-15" @click="resetCards()">
      {{grade.display_name}}
      <span v-if="grade.jenjang.nama === 'SMA'">
        <span v-if="$route.query.interest === 'SAINTEK'">(IPA)</span>
        <span v-if="$route.query.interest === 'SOSHUM'">(IPS)</span>
      </span>
    </button>
    <span v-for="(breadcrumb, index) in breadcrumbs" v-bind:key="index">
      <button class="btn btn-inverse m-r-10 m-b-15" @click="goTo(index)">{{breadcrumb.name}}</button>
    </span>
    <div class="row">
      <div class="input-group m-b-10 col-md-10">
        <input type="text" class="form-control" placeholder="Masukan kata kunci pencarian ..." v-model="query">
        <span class="input-group-addon"><i class="fa fa-search"></i></span>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success btn-block" v-on:click="showMappingModal = true"><i class="fa fa-plus"></i> Mapping</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12" v-for="(card, index) in filteredCards" v-bind:key="index">
        <div class="card-header" style="text-align: right; padding: 5px">
          <a v-if="allowDeletion(card)" href="javascript:;" class="btn btn btn-icon btn-danger" @click="confirmDeletion(card)"><i class="fa fa-trash"></i></a>
        </div>
        <div class="widget widget-stats" v-bind:class="bgColor(index)">
          <div class="stats-icon"><img :src="card.picture" alt="subject-logo" style="max-width: 100px"></div>
          <div class="stats-info" style="height: 80px">
            <h4>Kode: {{card.code}}</h4>
            <p>{{card.name}}</p>
          </div>
          <div class="stats-link" v-if="card.subs.length > 0">
            <a href="javascript:;" @click="selectedCard = card">Lihat Detail <i class="fa fa-arrow-circle-o-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <confirmation-modal v-if="deletedCard && showConfirmationModal" :withCancel="true" v-on:cancel="showConfirmationModal = false" v-on:ok="deleteMapping()">
      <h3 slot="header">Konfirmasi Penghapusan Mapping</h3>
      <p slot="body">Apakah anda yakin akan melakukan penghapusan mapping <strong style="color: red">{{deletedCard.name}}</strong> beserta sub bab / sub sub bab turunannya ?</p>
    </confirmation-modal>
    <topic-mapping-modal v-on:finish="onMappingFinished($event)" :topic="selectedCard" v-on:cancel="showMappingModal = false" v-if="showMappingModal"></topic-mapping-modal>
  </div>
</template>
<script>
import ItembankService from '@/services/itembank.js'
import TopicMappingModal from '@/components/kodifikasi/MappingModal'
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'topic-mapping-detail',
  data: function () {
    return {
      grade: null,
      cards: [],
      filteredCards: [],
      selectedCard: null,
      deletedCard: null,
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red'],
      showMappingModal: false,
      showConfirmationModal: false,
      isLoading: false,
      mapelId: null,
      babId: null,
      subBabId: null,
      subSubBabId: null,
      breadcrumbs: [],
      query: ''
    }
  },
  components: {
    'topic-mapping-modal': TopicMappingModal,
    'confirmation-modal': Modal,
    'app-spinner': Spinner
  },
  methods: {
    resetCards: function () {
      this.mapelId = null
      this.babId = null
      this.subBabId = null
      this.cards = []
      this.breadcrumbs = []

      var mappings = this.$ls.get('mappings')
      var context = this
      mappings.forEach(function (data) {
        var card = {
          id: data.mapel_id,
          type: 'mapel',
          code: data.mapel_code,
          picture: data.mapel_picture,
          name: data.mapel_name,
          subs: data.babs
        }

        context.cards.push(card)
      })
    },
    goTo: function (crumbIndex) {
      this.mapelId = null
      this.babId = null
      this.subBabId = null

      var context = this
      this.breadcrumbs.splice(crumbIndex + 1)
      this.breadcrumbs.forEach(function (crumb) {
        if (crumb.type === 'mapel') context.mapelId = crumb.id
        if (crumb.type === 'bab') context.babId = crumb.id
        if (crumb.type === 'sub_bab') context.subBabId = crumb.id
      })

      this.selectedCard = this.breadcrumbs[this.breadcrumbs.length - 1]
    },
    bgColor: function (id) {
      var index = id % 4
      return this.bgColors[index]
    },
    onMappingFinished: function (mappings) {
      var interest = this.$route.query.interest
      var gradeId = parseInt(this.$route.query.grade_id, 10)
      var context = this
      this.cards = []
      ItembankService.getTopicMappings(this.grade.id, interest, function (response) {
        if (response.success) {
          context.$ls.set('mappings', response.data)
          response.data.forEach(function (data) {
            var card = {
              id: data.mapel_id,
              type: 'mapel',
              code: data.mapel_code,
              picture: data.mapel_picture,
              name: data.mapel_name,
              subs: data.babs
            }

            context.cards.push(card)
          })
        }

        context.showMappingModal = false
      })
    },
    confirmDeletion: function (card) {
      this.showConfirmationModal = true
      this.deletedCard = card

      if (this.deletedCard.type === 'sub_bab') this.subBabId = card.id
      if (this.deletedCard.type === 'sub_sub_bab') this.subSubBabId = card.id
    },
    allowDeletion: function (card) {
      if (card.type === 'sub_bab') return true
      if (card.type === 'sub_sub_bab') return true

      return false
    },
    deleteMapping: function () {
      this.showConfirmationModal = false
      this.isloading = true
      var context = this

      ItembankService.deleteTopicMapping(
        this.mapelId, this.babId,
        this.subBabId, this.subSubBabId,
        this.$route.query.grade_id, this.$route.query.interest, function (response) {
        if (response.success) {
          var removeIndex = context.cards.findIndex(function (card) {
            return card.id === context.deletedCard.id
          })

          context.cards.splice(removeIndex, 1)
        }

        context.isLoading = false
      })
    },
    updateBreadcrumbs: function (card) {
      if (this.breadcrumbs.length > 0) {
        var last = this.breadcrumbs[this.breadcrumbs.length - 1]
        if (card.type !== last.type) this.breadcrumbs.push(card)
      } else {
        this.breadcrumbs.push(card)
      }
    }
  },
  watch: {
    query: function (val) {
      var filteredCards = this.cards.filter(function (card) {
        return card.name.toLowerCase().includes(val.toLowerCase())
      })

      this.filteredCards = filteredCards
    },
    cards: function (val) {
      this.filteredCards = val
      this.query = ''
    },
    selectedCard: function (val) {
      this.updateBreadcrumbs(val)
      this.cards = []
      var context = this
      if (val.type === 'mapel') this.mapelId = val.id
      else if (val.type === 'bab') this.babId = val.id
      else if (val.type === 'sub_bab') this.subBabId = val.id
      else if (val.type === 'sub_sub_bab') this.subSubBabId = val.id

      val.subs.forEach(function (sub) {
        if (val.type == 'mapel') {
          var card = {
            id: sub.bab_id,
            type: 'bab',
            code: sub.bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.bab_name,
            subs: sub.sub_babs
          }

          context.cards.push(card)
        } else if (val.type == 'bab') {
          var card = {
            id: sub.sub_bab_id,
            type: 'sub_bab',
            code: sub.sub_bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.sub_bab_name,
            subs: sub.sub_sub_babs
          }

          context.cards.push(card)
        } else if (val.type == 'sub_bab') {
          var card = {
            id: sub.sub_sub_bab_id,
            type: 'sub_sub_bab',
            code: sub.sub_sub_bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.sub_sub_bab_name,
            subs: []
          }

          context.cards.push(card)
        }
      })
    }
  },
  beforeMount: function () {
    var interest = this.$route.query.interest
    var gradeId = parseInt(this.$route.query.grade_id, 10)
    var grades = this.$ls.get('grades');
    var found = grades.find(function (grade) {
      return grade.id === gradeId
    })

    if (found) this.grade = found
    var context = this
    ItembankService.getTopicMappings(this.grade.id, interest, function (response) {
      if (response.success) {
        context.$ls.set('mappings', response.data)
        response.data.forEach(function (data) {
          var card = {
            id: data.mapel_id,
            type: 'mapel',
            code: data.mapel_code,
            picture: data.mapel_picture,
            name: data.mapel_name,
            subs: data.babs
          }

          context.cards.push(card)
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// TopicMappingDetail.vue?b212fe70